export default __webpack_public_path__ + "static/media/corporation.46b0020e.svg";